import jQuery from 'jquery';
import 'lity';

export function lightBoxPlugin() {
  jQuery(document).ready(function($) {  // Run once DOM is ready
      $("img.data-lity").each(function() {  //Iterate through each img element
      $(this).wrap('<a href="' + $(this).attr('src') + '" data-lity>'); //Wrap with link to own src
      });
  });
}
